import { action } from 'typesafe-actions';
import { BlackListTypes, IBlackList, IFilter, PaginationProps } from './types';

export const loadRequest = (
  tipoRegistro: string,
  filter?: IFilter,
  pagination?: PaginationProps
) => {
  return action(BlackListTypes.LOAD_REQUEST, { tipoRegistro, filter, pagination });
};

export const loadSuccess = (data: IBlackList, pagination: PaginationProps) => {
  return action(BlackListTypes.LOAD_SUCCESS, { data, pagination });
};

export const loadFailure = () => {
  return action(BlackListTypes.LOAD_FAILURE, {});
};

export const filterBlackList = (filter: IFilter) => {
  return action(BlackListTypes.FILTER_BLACKLIST, { filter });
};

export const cleanBlackList = () => {
  return action(BlackListTypes.CLEAN_BLACKLIST, {});
};
